import { useBottomPanel } from '@ubnt/link-core-ui/components/BottomPanel/context/BottomPanelContext';
import { PanelStatusBarProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/PanelStatusBar';

import { useSelector } from 'app/store';
import { devicesDeviceVariantFrequencyLabelSelector } from 'modules/devices/slice';
import SignalStatusBar from 'modules/bottomPanel/components/elements/SignalStatusBar';
import {
  linksLinkSignalIsErrorSelector,
  linksLinkSignalLabelSelector,
  linksLinkSignalValueSelector,
} from 'modules/links/slice';

const labelTextProps: PanelStatusBarProps['labelTextProps'] = {
  color: 'tertiary',
};

const valueTextProps: PanelStatusBarProps['valueTextProps'] = {
  weight: 'normal',
  size: 'body',
};

const SignalStatusBarContainer = (props: Partial<PanelStatusBarProps>) => {
  const { leftId, linkId } = useBottomPanel();

  const valueLabel = useSelector((state) => (linkId ? linksLinkSignalLabelSelector(state, linkId) : '-'));
  const valueError = useSelector((state) => (linkId ? linksLinkSignalIsErrorSelector(state, linkId) : false));

  const value = useSelector((state) => (linkId ? linksLinkSignalValueSelector(state, linkId) : 0));

  const frequencyLabel = useSelector((state) =>
    leftId ? devicesDeviceVariantFrequencyLabelSelector(state, leftId) : undefined
  );
  const label = `${frequencyLabel ? `${frequencyLabel} ` : ''}Signal`;

  return (
    <SignalStatusBar
      label={label}
      labelTextProps={labelTextProps}
      size="large2"
      value={value}
      valueError={valueError}
      valueLabel={valueLabel}
      valueTextProps={valueTextProps}
      {...props}
    />
  );
};

export default SignalStatusBarContainer;
